import React from "react";

interface CheckboxProps {
	checked?: boolean;
	checkboxClasses?: string;
	disabled?: boolean;
	id: string;
	label?: string | React.ReactNode;
	name?: string;
	onFocus?: () => void;
	onToggle: (value: string) => void;
	value?: string;
}

export default function Checkbox({
	checked,
	checkboxClasses,
	disabled,
	id,
	label,
	name,
	onFocus,
	onToggle,
	value,
}: CheckboxProps) {
	return (
		<div className="checkbox-input">
			<input
				type="checkbox"
				className={checkboxClasses}
				id={id}
				value={value}
				name={name}
				checked={checked}
				disabled={disabled}
				onFocus={onFocus}
				onChange={() => onToggle(value)}
			/>
			{label && <label htmlFor={id}>{label}</label>}
		</div>
	);
}
